import React, { useEffect, useState, useContext } from "react";

import FormModal from "../../ui/modal/Modal";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import EventsSection from "../events-section/eventsSection";
import Button from "../../atoms/button/button";
import GlobalContext from "../../../contexts/globalContext";
import { ReferenciaEvento } from "../../../interfaces/ReferenciaEvento";
import { graphql, useStaticQuery } from "gatsby";
import { saveForm, getToken, getCmdFormData } from "../../../services/formServices";

import "./eventWrapper.scss";

export interface CmdUserData {
    companyRole					:	string;
    topics						:	string;
    companyName					:	string;
    expectation_2				:	string;
    mobile						:	string;
    nit							:	string;
    fullName					:	string;
    documentId					:	string;
    expectations				:	string;
    email						:	string;
    dataProcessingAuthorization	:	string;
    eventId                     :   string;
    eventName                   :   string;
}

const EventSectionWrapper = (props: ReferenciaContenido) => {

    const data = useStaticQuery(graphql`
                query contentfulFormInscEventos{
                    form: allContentfulContactenos(
                        filter: { contentful_id: { eq: "5U7pJpWLmh1HUAI9UzMN2K" } }
                    ) {
                        nodes {
                            tituloPrincipal
                            descripcionFormulario {
                                raw
                            }
                            descripcion {
                                raw
                            }
                            metaTitulo
                            tituloFormulario
                            titulosFormulario {
                                tituloGeneral
                                descripcion {
                                    raw
                                }
                                referenciaFormulario {
                                    tipoCampo
                                    listaSelect
                                    mensajeError
                                    inputPrincipal
                                    nombreId
                                    tituloBotonTerminos
                                    textoTerminos {
                                        raw
                                    }
                                    obligatorio
                                    seccion
                                    tabOrder
                                }
                                tituloBoton
                            }
                        }
                    }
                    modalAlreadyRegistered: allContentfulContactenos(
                        filter: { contentful_id: { eq: "6WroyOy18yvu560deKAJgB" } }
                    ) {
                        nodes {
                            tituloPrincipal
                            descripcionFormulario {
                                raw
                            }
                            descripcion {
                                raw
                            }
                            metaTitulo
                            imagenFormulario {
                                file {
                                    url
                                }
                            }
                            tituloBoton
                            redireccionBoton
                            contentful_id
                        }
                    }
                }
    `);

    const formFieldsData:any[] = data.form.nodes[0].titulosFormulario[0].referenciaFormulario;
    const modalAlreadyRegistered = data.modalAlreadyRegistered.nodes[0];

    const Context = useContext(GlobalContext);
    let defaultModalContent:CmdUserData = {
        companyRole					:	"",
        topics						:	"",
        companyName					:	"",
        expectation_2				:	"",
        mobile						:	"",
        nit							:	"",
        fullName					:	"",
        documentId					:	"",
        expectations				:	"",
        email						:	"",
        dataProcessingAuthorization	:	"",
        eventId                     :   "",
        eventName                   :   ""
    };
    const [modalContent, setModalContent] = useState<CmdUserData>(defaultModalContent);
    const [isOpenModalRegistered, setIsOpenModalRegistered] = useState<boolean>(false);
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const [isOpenPopup, setIsOpenPopup] = useState<boolean>(false);

    useEffect(() => {
      if (Context.gigyaContext.gigyaAccount?.profile.email != "") {
        const getAccessData = async () => {
            const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
            const responseJson: any = await getCmdFormData(Context!.gigyaContext!.gigyaAccount!.data.docNumber, token);
            const cmdUserData:CmdUserData = responseJson.data.answerData;
            setModalContent({
                ...modalContent,
                ...cmdUserData
            });
        }
        getAccessData();
      }
    }, []);

    const handleModal = (eventData:ReferenciaEvento) => {
        const eventId = eventData.contentful_id!;
        const eventName = eventData.tituloEvento;
        setModalContent({
            ...modalContent,
            eventId,
            eventName
        });
        setIsOpenModal(true);
    };

    const formModalClose = () => {
        document.body.style.overflow = "scroll";
        setIsOpenModal((setShow) => !setShow);
    };

    const formModalRegClose = () => {
        document.body.style.overflow = "scroll";
        setIsOpenModalRegistered((setShow) => !setShow);
    };

    const formModalConfirm = async () => {
        document.body.style.overflow = "scroll";
        const responseData = await handleSubmitForm();
        setIsOpenModal((setShow) => !setShow);
        if (responseData.data.status === 200) {
            setIsOpenPopup(true);
        }
        else {
            setIsOpenModalRegistered(true);
        }
    };

    const handleSubmitForm = async () => {
        const payload: any = {
            idForm: 4,
            answers: [],
        };
        let formValues = {
            nit         : modalContent.nit,
            companyName : modalContent.companyName,
            fullName    : modalContent.fullName,
            mobile      : modalContent.mobile,
            email       : modalContent.email,
            eventName   : modalContent.eventName,
            eventId     : modalContent.eventId
        };
        Object.entries(formValues).forEach(([key, value]) => {
            payload.answers.push({ contentfulId: key, answer: value });
        });
        const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
        const response = await saveForm(payload, token);
        return response;
    };

    const [showPopup, setShowPopup] = useState(true);
    useEffect(() => {
        const timeId = setTimeout(() => {
            setShowPopup(false)
        }, 6000)
        return () => {
            clearTimeout(timeId)
        }
    }, []);

    const Popup = ({ children }) => {
        if (!showPopup) {
            return null;
        }
        return (
            <div className={`alert alert-info`}>
                {children}
            </div>
        )
    }

    return (
        <>
            {/* MODAL YA INSCRITO */}
            {isOpenModalRegistered && (
                <FormModal showModal={isOpenModalRegistered} onClose={formModalRegClose}>

                    <div className="m-modal-content">

                        <div className="m-modal-content__form">
                            <div className="m-modal-content__form__item">
                                <div className="m-modal-content__form__item__label">
                                    <img src={modalAlreadyRegistered.imagenFormulario.file.url}/>
                                </div>
                                <div className="m-modal-content__form__item__msg">
                                    {modalAlreadyRegistered.tituloPrincipal}
                                </div>
                            </div>
                        </div>

                        <div className="m-modal-content__form__buttonbar">
                            <div className="m-modal-content__form__buttonbar__msgbutton">
                                <Button
                                    type="button"
                                    text="ACEPTAR"
                                    classname={`a-button__magenta m-modal__button`}
                                    isDisabled={false}
                                    onClickAction={formModalRegClose}
                                />
                            </div>
                        </div>
                    </div>
                </FormModal>
            )}

            {/* MODAL INSCRIPCION */}
            {isOpenModal && (
                <FormModal showModal={isOpenModal} onClose={formModalClose}>
                    <div className="m-modal-content">

                        <h2 className="m-modal-content__title">
                            Confirma tu inscripción a este evento
                        </h2>

                        <div className="m-modal-content__form">
                            {formFieldsData.map((field, index) => {
                                return (
                                    <>
                                        <div className={`m-modal-content__form__item ${field.inputPrincipal}`}>
                                            <div className="m-modal-content__form__item__label">
                                                {field.inputPrincipal}
                                            </div>
                                            <div className="m-modal-content__form__item__value">
                                                {modalContent[field.nombreId]}
                                            </div>
                                        </div>
                                    </>
                                )
                            })}
                        </div>

                        <div className="m-modal-content__form__buttonbar">
                            <div className="m-modal-content__form__buttonbar__button">
                                <Button
                                    type="button"
                                    text="CANCELAR"
                                    classname={`a-button__magenta m-modal__button cancel`}
                                    isDisabled={false}
                                    onClickAction={formModalClose}
                                />
                            </div>
                            <div className="m-modal-content__form__buttonbar__button">
                                <Button
                                type="button"
                                text="CONFIRMAR"
                                classname={`a-button__magenta m-modal__button confirm`}
                                isDisabled={false}
                                onClickAction={formModalConfirm}
                                />
                            </div>
                        </div>
                    </div>
                </FormModal>
            )}

            {isOpenPopup && (
                <Popup>
                    Registro confirmado
                </Popup>
            )}

            <EventsSection
                {...props}
                handleModal={handleModal}
            />
        </>
    );
};

export default EventSectionWrapper;
